export enum UserStatus {
  Approved = 1,
  Pending = 2,
  Rejected = 3,
  Suspended = 4,
  UpdatedAwaitingManualApproval = 5,
}
